import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === "currency") {
          return new Intl.NumberFormat("fr-FR", {
            style: "currency",
            currency: "EUR", 
          }).format(value);
        }
        if (format === "date") {
          return new Intl.DateTimeFormat(lng, {
            day: "numeric",
            month: "long",
            year: "numeric",
          }).format(new Date(value));
        }
        if (format === "dateTime") {
          let date;
          if (typeof value === "string") {
            if (!value.includes("Z") && !value.match(/[+-]\d{2}:\d{2}$/)) {
              date = new Date(value.includes("T") ? value + "Z" : value);
            } else {
              date = new Date(value);
            }
          } else {
            date = new Date(value);
          }
          
          const locale = lng || navigator.language || "en";
          
          return new Intl.DateTimeFormat(locale, {
            day: "numeric",
            month: "long",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          }).format(date);
        }
        return value;
      }
    },
    react: {
      useSuspense: false
    },
    backend: {
      loadPath: "/locales/{{lng}}/pixcart.translation.json"
    }
  });

export default i18n;
